import { h } from 'preact';

const Reset = (props) => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" role="img" {...props}>
			<path d="M15,9c0,3.859-3.14,7-7,7c-3.859,0-7-3.141-7-7c0-3.86,3.141-7,7-7c0.106,0,0.211,0.02,0.317,0.024l-1.171-1.17 c-0.195-0.196-0.195-0.512,0-0.708c0.196-0.195,0.512-0.195,0.708,0l2,2c0.195,0.196,0.195,0.512,0,0.708l-2,2 c-0.196,0.195-0.512,0.195-0.708,0C7.049,4.756,7,4.628,7,4.5s0.049-0.256,0.146-0.354l1.126-1.125C8.181,3.017,8.092,3,8,3 C4.691,3,2,5.691,2,9s2.691,6,6,6s6-2.691,6-6c0-0.843-0.171-1.658-0.509-2.421c-0.113-0.253,0.003-0.548,0.256-0.66 c0.252-0.111,0.547,0.003,0.659,0.255C14.8,7.066,15,8.017,15,9z" />
		</svg>
	);
};

export default Reset;
